import fulfill from '../../fulfill';
import { CORE_API_HOSTNAME } from '../../env';
import { SideEffectFunction } from '../../sideEffects';
import {
    ActionTypes,
    FetchDiscounts,
    FetchDiscountsResponse,
    FetchCampaign,
    FetchCampaignResponse,
    CreateDiscount,
    CreateDiscountResponse,
    UpdateCampaign,
    UpdateCampaignResponse,
    UpdateDiscount,
    UpdateDiscountResponse,
    DeleteDiscount,
    DeleteDiscountResponse
} from './actions';
import { Discount, Campaign } from '../../types/discounts';

export const fetchCampaign: SideEffectFunction<FetchCampaign, FetchCampaignResponse> = async action => {
    const { accountId, campaignId } = action.payload;
    const result: FetchCampaignResponse = await fulfill.get({
        accountId: action.payload.accountId,
        url: `${CORE_API_HOSTNAME}/v1/accounts/${accountId}/discounts/campaigns/${campaignId}`,
        handlers: {
            200: (campaign: Campaign) => ({
                type: ActionTypes.FetchCampaignResponse,
                payload: campaign,
                meta: {
                    cause: action,
                },
            }),
        },
    });
    return result;
};

export const fetchDiscounts: SideEffectFunction<FetchDiscounts, FetchDiscountsResponse> = async action => {
    const { accountId, campaignId } = action.payload;
    const result: FetchDiscountsResponse = await fulfill.get({
        accountId,
        url: `${CORE_API_HOSTNAME}/v1/accounts/${accountId}/discounts/rules?limit=100&campaign_id=${campaignId}&state=available`,
        handlers: {
            200: (discounts: Discount[]) => ({
                type: ActionTypes.FetchDiscountsResponse,
                payload: discounts,
                meta: {
                    cause: action,
                },
            }),
        },
    });
    return result;
};

export const updateCampaign: SideEffectFunction<UpdateCampaign, UpdateCampaignResponse> = async action => {
    const { accountId, campaignId, ...json } = action.payload;
    const result: UpdateCampaignResponse = await fulfill.put({
        accountId,
        url: `${CORE_API_HOSTNAME}/v1/accounts/${accountId}/discounts/campaigns/${campaignId}`,
        json: json.campaign,
        handlers: {
            200: (campaign: Campaign) => ({
                type: ActionTypes.UpdateCampaignResponse,
                payload: campaign,
                meta: {
                    cause: action,
                },
            }),
        },
    });
    return result;
};

export const updateDiscount: SideEffectFunction<UpdateDiscount, UpdateDiscountResponse> = async action => {
    const { accountId, discountId, ...json } = action.payload;
    const result: UpdateDiscountResponse = await fulfill.put({
        accountId,
        url: `${CORE_API_HOSTNAME}/v1/accounts/${accountId}/discounts/rules/${discountId}`,
        json: json.discount,
        handlers: {
            200: (discount: Discount) => ({
                type: ActionTypes.UpdateDiscountResponse,
                payload: discount,
                meta: {
                    cause: action,
                },
            }),
        },
    });
    return result;
};

export const createDiscount: SideEffectFunction<CreateDiscount, CreateDiscountResponse> = async action => {
    const { accountId, ...json } = action.payload;
    const result: CreateDiscountResponse = await fulfill.post({
        accountId,
        url: `${CORE_API_HOSTNAME}/v1/accounts/${accountId}/discounts/rules`,
        json: json.discount,
        handlers: {
            200: () => ({
                type: ActionTypes.CreateDiscountResponse,
                payload: json,
                meta: {
                    cause: action,
                },
            }),
        },
    });
    return result;
};

export const deleteDiscount: SideEffectFunction<DeleteDiscount, DeleteDiscountResponse> = async action => {
    const { accountId, discountId } = action.payload;
    const result: DeleteDiscountResponse = await fulfill.delete({
        accountId,
        url: `${CORE_API_HOSTNAME}/v1/accounts/${accountId}/discounts/rules/${discountId}`,
        handlers: {
            200: () => ({
                type: ActionTypes.DeleteDiscountResponse,
                meta: {
                    cause: action,
                },
            }),
        },
    });
    return result;
};

const effects = {
    [ActionTypes.FetchDiscounts]: fetchDiscounts,
    [ActionTypes.FetchCampaign]: fetchCampaign,
    [ActionTypes.UpdateCampaign]: updateCampaign,
    [ActionTypes.UpdateDiscount]: updateDiscount,
    [ActionTypes.CreateDiscount]: createDiscount,
    [ActionTypes.DeleteDiscount]: deleteDiscount,
};

export default effects;
